/** @format */
import { Component, ReactNode } from 'react';

import { logger } from '@toucan/client/global/application';

type JourneyBoundaryProps = {
    children: ReactNode;
};

type JourneyBoundaryState = {
    hasFailed: boolean;
};

/**
 * Keeps a failure inside the journey to the journey.
 *
 * The section is an experiment sitting in the middle of a page that sells
 * things, so anything it throws while rendering has to stop here rather than
 * take the model page down with it. When that happens the section simply is not
 * there, which is the same outcome as a model with no journey to show.
 */
export class JourneyBoundary extends Component<
    JourneyBoundaryProps,
    JourneyBoundaryState
> {
    state: JourneyBoundaryState = { hasFailed: false };

    static getDerivedStateFromError(): JourneyBoundaryState {
        return { hasFailed: true };
    }

    componentDidCatch(error: Error) {
        logger.error(error);
    }

    render() {
        if (this.state.hasFailed) {
            return null;
        }

        return this.props.children;
    }
}
